import React from "react";
import { Props } from "./types";

function SearchIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 53.892 53.892">
      <g transform="translate(-1.5 -1.5)">
        <path
          d="M45.966,25.233A20.733,20.733,0,1,1,25.233,4.5,20.733,20.733,0,0,1,45.966,25.233Z"
          transform="translate(0)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="6"
        />
        <path
          d="M36.249,36.249,24.975,24.975"
          transform="translate(14.901 14.901)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="6"
        />
      </g>
    </svg>
  );
}

export { SearchIcon };
